// extracted by mini-css-extract-plugin
module.exports = {"THead1":"_2i0rQ1GZLPZBHEQOkH-JIA","THead2":"_361EPiAWUZhca0kzn78DSG"};